/* eslint-disable camelcase */
import React from 'react';
import { useTranslation } from 'react-i18next';

const InfoTable = ({ data }) => {
  const { t } = useTranslation('common');
  const {
    budget,
    description,
    email,
    phone,
    start_date,
    status,
    name,
    estimate,
    source,
    manager,
    utm_source,
    utm_medium,
    utm_campaign,
    referrer_url,
    page_url,
  } = data;

  return (
    <table className="project-summary__info">
      <tbody>
        <tr>
          <th>{t('leads.single_summary.name')}</th>
          <td>
            <p>{name}</p>
          </td>
        </tr>
        <tr>
          <th>{t('leads.single_summary.source')}</th>
          <td>
            <p>{source}</p>
          </td>
        </tr>
        {!manager?.name && (
          <tr>
            <th>{t('leads.single_summary.manager')}</th>
            <td>
              <p>{t('leads.single_summary.via_api')}</p>
            </td>
          </tr>
        )}
        <tr>
          <th>{t('leads.single_summary.status')}</th>
          <td>
            <p>{status}</p>
          </td>
        </tr>
        <tr>
          <th>{t('leads.single_summary.email')}</th>
          <td>
            <p>{email}</p>
          </td>
        </tr>
        <tr>
          <th>{t('leads.single_summary.phone')}</th>
          <td>
            <p>{phone}</p>
          </td>
        </tr>
        <tr>
          <th>{t('leads.single_summary.start')}</th>
          <td>
            <p>{start_date}</p>
          </td>
        </tr>
        <tr>
          <th>{t('leads.single_summary.budget')}</th>
          <td>
            <p>{budget}</p>
          </td>
        </tr>
        <tr>
          <th>{t('leads.single_summary.estimate')}</th>
          <td>
            <p>{estimate}</p>
          </td>
        </tr>
        <tr>
          <th>{t('leads.single_summary.description')}</th>
          <td>
            <p>{description}</p>
          </td>
        </tr>
        {(utm_source || utm_medium || utm_campaign || referrer_url || page_url) && (
          <>
            {utm_source && (
              <tr>
                <th>{t('leads.single_summary.utm_source')}</th>
                <td><p>{utm_source}</p></td>
              </tr>
            )}
            {utm_medium && (
              <tr>
                <th>{t('leads.single_summary.utm_medium')}</th>
                <td><p>{utm_medium}</p></td>
              </tr>
            )}
            {utm_campaign && (
              <tr>
                <th>{t('leads.single_summary.utm_campaign')}</th>
                <td><p>{utm_campaign}</p></td>
              </tr>
            )}
            {referrer_url && (
              <tr>
                <th>{t('leads.single_summary.referrer_url')}</th>
                <td><p>{referrer_url}</p></td>
              </tr>
            )}
            {page_url && (
              <tr>
                <th>{t('leads.single_summary.page_url')}</th>
                <td><p>{page_url}</p></td>
              </tr>
            )}
          </>
        )}
      </tbody>
    </table>
  );
};

export default InfoTable;
